export default __webpack_public_path__ + "static/media/kasa_white_logo.ee689fd9.svg";